import { add, format } from 'date-fns'

export const MONTH_FORMAT = 'MMM'
const MONTH_WITH_YEAR_FORMAT = 'MMM yyyy'
export const NUM_MONTHS = 12
const WIDTH = 100 / (NUM_MONTHS - 1)

export const getLeftPosition = (i: number) => `${Math.round(i * WIDTH * 100) / 100}%`

export const getMonthLabels = (startMonth: Date, showYear: boolean): string[] => {
  const monthLabels: string[] = []

  for (let i = 0; i < NUM_MONTHS; i++) {
    monthLabels.push(format(add(startMonth, { months: i }), showYear ? MONTH_WITH_YEAR_FORMAT : MONTH_FORMAT))
  }

  return monthLabels
}
